export default __webpack_public_path__ + "static/media/zenith-logo.59534030.svg";